import { Divider, Stack, Typography } from '@mui/material';
import { References } from '/@/components/crop-monitoring/gdu-graphic';

const CropMonitoringResultGraphic = ({
    title,
    description,
    children,
    references,
}: {
    title: string;
    description: string;
    children: React.ReactNode;
    references: { color: string; label: string }[];
}) => {
    return (
        <Stack
            data-testid='crop-monitoring-result-graphic-stack'
            sx={{
                border: (t) => `1px solid ${t.palette.divider}`,
                height: '100%',
            }}
        >
            <Stack p={2} mb='auto'>
                <Typography variant='h6' color='primary'>
                    {title}
                </Typography>
                {description && (
                    <Typography variant='body2' color='primary.mui.inactive'>
                        {description}
                    </Typography>
                )}
            </Stack>
            <Divider />
            <Stack spacing={3} p={2}>
                {children}
            </Stack>
            {!!references.length && (
                <Stack mt='auto'>
                    <References references={references} />
                </Stack>
            )}
        </Stack>
    );
};

export const CustomTooltipRow = ({ label, value, color, unit }) => (
    <Stack direction='row' spacing={1} alignItems='center'>
        <div style={{ height: 5, width: 5, backgroundColor: color, borderRadius: '50%' }} />
        <Typography color='primary'>{`${label}: ${value} ${unit}`}</Typography>
    </Stack>
);

export default CropMonitoringResultGraphic;
